// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"8837b283","336":"e61475c6","453":"55041bb9","739":"bb21f27b","807":"392bdc2f","818":"e8b6da69","847":"6a21614f","915":"9e7aff23","976":"9d018c9e"}[chunkId] + ".chunk.js";
};